import { useRef } from 'react';

import { LOYALTY_PAGE_ID } from '@/services/content-a/fetch-general-page';

import { useCmsLightModeLockWorkaround } from './useCmsLightModeLockWorkaround';

interface CmsMfeZoneProps {
  zoneId: number;
  selectionKey?: string;
  experiments?: string;
}

export const CmsMfeZone = ({ zoneId, selectionKey, experiments }: CmsMfeZoneProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useCmsLightModeLockWorkaround({ containerRef, selectionKey });

  // For loyalty content, pageType is always "general/types/loyalty-sign-up"
  const pageType = `general/types/${LOYALTY_PAGE_ID}`;

  const attributes = [
    `data-testid="chewy-cms-zone-${zoneId}"`,
    `zone-id="${zoneId}"`,
    `page-type="${pageType}"`,
    ...(selectionKey ? [`selection-key="${selectionKey}"`] : []),
    ...(experiments ? [`experiments="${experiments}"`] : []),
  ].join(' ');

  const htmlString = `<chewy-cms-zone ${attributes}></chewy-cms-zone>`;

  return (
    <div
      dangerouslySetInnerHTML={{ __html: htmlString }}
      data-testid={`cms-zone-${zoneId}`}
      ref={containerRef}
      suppressHydrationWarning={true}
    />
  );
};
